import {

  GET_DEALER_ORDERS_INVOICES_DT,
  GET_DEALER_ORDERS_INVOICES_DT_OK,
  GET_DEALER_ORDERS_INVOICES_DT_ERR,
  DO_DEALER_ORDERS_INVOICES_DT_CLEANUP,

  APPLY_DEALER_ORDERS_INVOICES_DT_FILTERS,
  PATCH_DEALER_ORDERS_INVOICES_DT_FILTERS,
  CLEAR_DEALER_ORDERS_INVOICES_DT_FILTERS,
  UNSET_DEALER_ORDERS_INVOICES_DT_FILTERS,
} from "./actionTypes";

/********** DATATABLE **********/

export const getDealerOrdersInvoicesDt = params => ({
  type: GET_DEALER_ORDERS_INVOICES_DT,
  payload: { params },
});

export const getDealerOrdersInvoicesDtOk = response => ({
  type: GET_DEALER_ORDERS_INVOICES_DT_OK,
  payload: { response },
});

export const getDealerOrdersInvoicesDtErr = error => ({
  type: GET_DEALER_ORDERS_INVOICES_DT_ERR,
  payload: { error },
});

export const doDealerOrdersInvoicesDtCleanup = () => ({
  type: DO_DEALER_ORDERS_INVOICES_DT_CLEANUP,
});

/********** DATATABLE FILTERS **********/


export const applyDealerOrdersInvoicesDtFilters = filters => ({
  type: APPLY_DEALER_ORDERS_INVOICES_DT_FILTERS,
  payload: { filters },
});

export const patchDealerOrdersInvoicesDtFilters = filters => ({
  type: PATCH_DEALER_ORDERS_INVOICES_DT_FILTERS,
  payload: { filters },
});

export const clearDealerOrdersInvoicesDtFilters = () => ({
  type: CLEAR_DEALER_ORDERS_INVOICES_DT_FILTERS,
});

export const unsetDealerOrdersInvoicesDtFilters = () => ({
  type: UNSET_DEALER_ORDERS_INVOICES_DT_FILTERS,
});